import Icon from "@lib/common/components/Icon/Icon";
import { Group, Stack, Text, ThemeIcon } from "@mantine/core";

/** What the agent chat shows before the first message: what the chat is for, and what it can do.
 *
 * The flag arrives as a prop rather than from `useFeatureFlag` so the component stays renderable
 * outside the app (the sandbox mounts no PostHog provider), matching how ChatBox takes it.
 */
export default function ChatEmptyState({ isDeepResearchEnabled }: { isDeepResearchEnabled: boolean }) {
  return (
    <Stack gap="md" maw={600}>
      <ThemeIcon color="gray" variant="light" radius="md" size="3rem" style={{ boxShadow: "var(--mantine-shadow-xs)" }}>
        <Icon name="messages" size="1.5rem" color="blue" />
      </ThemeIcon>

      <Group gap="xs" align="center">
        <Text size="md" fw={600}>
          Start with your experiment
        </Text>
      </Group>
      <Text>
        Describe what you want to investigate, and I&rsquo;ll turn it into a draft in the workspace next to this chat.
        You can edit any field yourself at any time — we&rsquo;ll stay in sync.
      </Text>
      {isDeepResearchEnabled && (
        <Text>
          Need more context? Ask me to perform Deep Research on your topic and use the resulting report as Expert
          Context.
        </Text>
      )}
      <Text>After each optimization, I can also explain the recommendations and the reasoning behind them.</Text>
    </Stack>
  );
}
